const DEFAULT_PRODUCTION_ORIGIN = 'https://www.hkinds.com';

const trimTrailingSlash = (value = '') => String(value).replace(/\/+$/, '');

const getBrowserOrigin = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return trimTrailingSlash(window.location.origin || '');
};

const getApiOrigin = () => {
  const configuredOrigin = trimTrailingSlash(process.env.REACT_APP_API_ORIGIN || '');

  if (configuredOrigin) {
    return configuredOrigin;
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8000';
  }

  return getBrowserOrigin() || DEFAULT_PRODUCTION_ORIGIN;
};

const API_ORIGIN = getApiOrigin();
const API_BASE_URL = `${API_ORIGIN}/api`;

export const API_URL = {
  ORIGIN: API_ORIGIN,
  BASE: API_BASE_URL,
  PRODUCTS: `${API_BASE_URL}/products`,
  BANNERS: `${API_BASE_URL}/banners`,
  CERTIFICATES: `${API_BASE_URL}/certificates`,
  CONTACTS: `${API_BASE_URL}/contacts`,
  CATALOGS: `${API_BASE_URL}/catalogs`,
  ENQUIRIES: `${API_BASE_URL}/enquiries`,
  NEWS: `${API_BASE_URL}/news`,
  NEWSLETTER_SUBSCRIBERS: `${API_BASE_URL}/newsletter-subscribers`,
  PRODUCT_PAGE_INQUIRIES: `${API_BASE_URL}/product-page-inquiries`,
  PRODUCT_PAGE_DOWNLOAD_CATALOGS: `${API_BASE_URL}/product-page-download-catalogs`,
  SITE_CONTENT: `${API_BASE_URL}/site-content`,
};

export function apiPath(...segments) {
  const path = segments
    .filter((segment) => segment !== undefined && segment !== null && String(segment).trim() !== '')
    .map((segment) => encodeURIComponent(String(segment)).replace(/%2F/g, '/'))
    .join('/');

  return path ? `${API_BASE_URL}/${path}` : API_BASE_URL;
}

export default API_URL;
